/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ActivateUserDto,
  PasswordResetDto,
  ValidateAndActivateAccountParams,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **Public access**
 */
export const requestAccountPasswordReset = (
  requestAccountPasswordResetBody: BodyType<string>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/account/password-reset`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestAccountPasswordResetBody,
      signal,
    },
    options
  );
};

export const getRequestAccountPasswordResetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestAccountPasswordReset>>,
    TError,
    { data: BodyType<string> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestAccountPasswordReset>>,
  TError,
  { data: BodyType<string> },
  TContext
> => {
  const mutationKey = ['requestAccountPasswordReset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestAccountPasswordReset>>,
    { data: BodyType<string> }
  > = (props) => {
    const { data } = props ?? {};

    return requestAccountPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestAccountPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestAccountPasswordReset>>
>;
export type RequestAccountPasswordResetMutationBody = BodyType<string>;
export type RequestAccountPasswordResetMutationError = ErrorType<unknown>;

export const useRequestAccountPasswordReset = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof requestAccountPasswordReset>>,
      TError,
      { data: BodyType<string> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof requestAccountPasswordReset>>,
  TError,
  { data: BodyType<string> },
  TContext
> => {
  return useMutation(
    getRequestAccountPasswordResetMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **Public access**
 */
export const completeAccountPasswordReset = (
  passwordResetDto: BodyType<PasswordResetDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/account/password-reset/new-password`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: passwordResetDto,
      signal,
    },
    options
  );
};

export const getCompleteAccountPasswordResetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeAccountPasswordReset>>,
    TError,
    { data: BodyType<PasswordResetDto> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeAccountPasswordReset>>,
  TError,
  { data: BodyType<PasswordResetDto> },
  TContext
> => {
  const mutationKey = ['completeAccountPasswordReset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeAccountPasswordReset>>,
    { data: BodyType<PasswordResetDto> }
  > = (props) => {
    const { data } = props ?? {};

    return completeAccountPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteAccountPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeAccountPasswordReset>>
>;
export type CompleteAccountPasswordResetMutationBody =
  BodyType<PasswordResetDto>;
export type CompleteAccountPasswordResetMutationError = ErrorType<unknown>;

export const useCompleteAccountPasswordReset = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeAccountPasswordReset>>,
      TError,
      { data: BodyType<PasswordResetDto> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof completeAccountPasswordReset>>,
  TError,
  { data: BodyType<PasswordResetDto> },
  TContext
> => {
  return useMutation(
    getCompleteAccountPasswordResetMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **Public access**
 */
export const validateAndActivateAccount = (
  params: ValidateAndActivateAccountParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    { url: `/api/account/activate`, method: 'GET', params, signal },
    options
  );
};

export const getValidateAndActivateAccountQueryKey = (
  params?: ValidateAndActivateAccountParams
) => {
  return [`/api/account/activate`, ...(params ? [params] : [])] as const;
};

export const getValidateAndActivateAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof validateAndActivateAccount>>,
  TError = ErrorType<unknown>
>(
  params: ValidateAndActivateAccountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof validateAndActivateAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getValidateAndActivateAccountQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof validateAndActivateAccount>>
  > = ({ signal }) =>
    validateAndActivateAccount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof validateAndActivateAccount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ValidateAndActivateAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof validateAndActivateAccount>>
>;
export type ValidateAndActivateAccountQueryError = ErrorType<unknown>;

export function useValidateAndActivateAccount<
  TData = Awaited<ReturnType<typeof validateAndActivateAccount>>,
  TError = ErrorType<unknown>
>(
  params: ValidateAndActivateAccountParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof validateAndActivateAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateAndActivateAccount>>,
          TError,
          Awaited<ReturnType<typeof validateAndActivateAccount>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useValidateAndActivateAccount<
  TData = Awaited<ReturnType<typeof validateAndActivateAccount>>,
  TError = ErrorType<unknown>
>(
  params: ValidateAndActivateAccountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof validateAndActivateAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateAndActivateAccount>>,
          TError,
          Awaited<ReturnType<typeof validateAndActivateAccount>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useValidateAndActivateAccount<
  TData = Awaited<ReturnType<typeof validateAndActivateAccount>>,
  TError = ErrorType<unknown>
>(
  params: ValidateAndActivateAccountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof validateAndActivateAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useValidateAndActivateAccount<
  TData = Awaited<ReturnType<typeof validateAndActivateAccount>>,
  TError = ErrorType<unknown>
>(
  params: ValidateAndActivateAccountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof validateAndActivateAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getValidateAndActivateAccountQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **Public access**
 */
export const activateUserAccount = (
  activateUserDto: BodyType<ActivateUserDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/account/activate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: activateUserDto,
      signal,
    },
    options
  );
};

export const getActivateUserAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateUserAccount>>,
    TError,
    { data: BodyType<ActivateUserDto> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateUserAccount>>,
  TError,
  { data: BodyType<ActivateUserDto> },
  TContext
> => {
  const mutationKey = ['activateUserAccount'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateUserAccount>>,
    { data: BodyType<ActivateUserDto> }
  > = (props) => {
    const { data } = props ?? {};

    return activateUserAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateUserAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateUserAccount>>
>;
export type ActivateUserAccountMutationBody = BodyType<ActivateUserDto>;
export type ActivateUserAccountMutationError = ErrorType<unknown>;

export const useActivateUserAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof activateUserAccount>>,
      TError,
      { data: BodyType<ActivateUserDto> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof activateUserAccount>>,
  TError,
  { data: BodyType<ActivateUserDto> },
  TContext
> => {
  return useMutation(
    getActivateUserAccountMutationOptions(options),
    queryClient
  );
};
